<template>
  <div>
    <div class="d-none d-md-block">
      <v-timeline align-top dense v-if="!isEverythingEmpty()">
        <timeline-regular :data="{ ...everything.today, title: 'Today' }" />
        <timeline-regular
          :data="{ ...everything.tomorrow, title: 'Tomorrow' }"
        />
        <timeline-regular :data="{ ...everything.next, title: 'Upcoming' }" />
      </v-timeline>
      <div v-else>
        <v-img src="/no-everything.svg" :contain="true" height="300" />
      </div>
    </div>

    <div class="d-md-none">
      <div v-if="!isEverythingEmpty()">
        <timeline-small :data="{ ...everything.today, title: 'Today' }" />
        <v-divider />
        <timeline-small :data="{ ...everything.tomorrow, title: 'Tomorrow' }" />
        <v-divider />
        <timeline-small :data="{ ...everything.next, title: 'Upcoming' }" />
      </div>
      <div v-else>
        <v-img src="/no-everything.svg" :contain="true" height="300" />
      </div>
    </div>
  </div>
</template>

<script>
import TimelineRegular from "@/views/protected/dashboard/timeline-regular";
import TimelineSmall from "@/views/protected/dashboard/timeline-small";

export default {
  name: "ActivitiesEverything",
  props: ["everything"],
  components: {
    TimelineSmall,
    TimelineRegular,
  },
  methods: {
    isEverythingEmpty() {
      if (!this.everything) return true;
      if (
        !this.everything.next &&
        !this.everything.today &&
        !this.everything.tomorrow
      ) {
        return true;
      }
      return (
        !this.everything.next.data &&
        !this.everything.tomorrow.data &&
        !this.everything.today.data
      );
    },
  },
};
</script>

<style scoped>
</style>
